/**
 * Formatting helpers for agent-eval proof shown on capabilities.
 *
 * @module features/product-map/evalProof
 */

import type { EvalLatestRun } from './types';

/** `0..1` pass rate as a whole-number percentage, e.g. `0.875` -> `88%`. */
export function formatPassRate(passRate: number): string {
  return `${Math.round(passRate * 100)}%`;
}

export function evalVerdictLabel(verdict: EvalLatestRun['verdict']): 'Pass' | 'Fail' {
  return verdict === 'pass' ? 'Pass' : 'Fail';
}

export function evalVerdictVariant(verdict: EvalLatestRun['verdict']): 'success' | 'destructive' {
  return verdict === 'pass' ? 'success' : 'destructive';
}
